import { render, staticRenderFns } from "./ServiziPeriodici.vue?vue&type=template&id=7fdb16cb&"
import script from "./ServiziPeriodici.vue?vue&type=script&lang=ts&"
export * from "./ServiziPeriodici.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports